export const rankingScale = ['1st', '2nd', '3rd', '4th'];
